<template>
  <div class="regulationsExtention">
    <el-tabs v-model="activeName">
      <el-tab-pane label="基本信息" name="name0">开发中，敬请期待......</el-tab-pane>
      <el-tab-pane label="关联法规" name="name1">
        <div>
          同属
          <span class="label">{{regulationsExt.committee}}</span>发布的法规/规章还包括：
        </div>
        <div class="committee">
          <committee />
        </div>
      </el-tab-pane>
      <el-tab-pane label="条款解读" name="name2">开发中，敬请期待......</el-tab-pane>
      <el-tab-pane label="分析问卷" name="name3">开发中，敬请期待......</el-tab-pane>
      <el-tab-pane label="管理制度" name="name4">开发中，敬请期待......</el-tab-pane>
      <el-tab-pane label="技术措施" name="name5">开发中，敬请期待......</el-tab-pane>
      <el-tab-pane label="培训视频" name="name6">开发中，敬请期待......</el-tab-pane>
      <el-tab-pane label="其他参考" name="name7">开发中，敬请期待......</el-tab-pane>
      <el-tab-pane label="自由讨论" name="name8">开发中，敬请期待......</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import committee from "@/components/regulations/serials/committee.vue";
  export default {
    data() {
      return {
        activeName: "name1"
      };
    },
    props: {
      regulationsExt: Object
    },
    components: {
      committee
    },
    created() {
      //获取相关的法规清单
      if (this.regulationsExt.committee != null) {
        this.$store.dispatch(
          "regulations/getCommittee",
          this.regulationsExt.committee
        );
      }
    }
  };
</script>

<style scoped>
  .regulationsExtention {
    height: calc(100vh - 1.5rem);
    margin-top: 0.2rem;
    padding-bottom: 0.2rem
  }

  .regulationsExtention .label {
    background-color: #efefef;
    color: black;
    margin: 0 0.05rem;
    padding: 0.025rem 0.05rem;
  }
</style>

<style>
  .regulationsExtention .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: gray !important
  }


  .regulationsExtention .el-tabs__item {
    font-size: 0.12rem !important;
    color: black !important;
  }

  .regulationsExtention .el-tabs__item.is-active {
    color: white !important;
    background-color: #aa0000 !important;
    border-bottom: 1px solid gray !important;
    padding: 0 0.1rem !important;
  }

  .regulationsExtention .el-tabs__item:hover {
    color: white !important;
    background-color: gray !important;
  }
</style>